// SettlementPayrollHistoryReport.ts
// Event handler for Settlement Payroll History report layout

import { AutogenLayoutSettlementPayrollHistoryReport } from "./autogen/AutogenLayoutSettlementPayrollHistoryReport";


export class SettlementPayrollHistoryReport extends AutogenLayoutSettlementPayrollHistoryReport {

    reportTypeChanged() {
        const isSummary = !this.switchReportType?.checked;
        
        if (this.checkboxIncludeDeductionHistory) {
            this.checkboxIncludeDeductionHistory.checked = false;
            this.checkboxIncludeDeductionHistory.enabled = !isSummary;
        }
    }
}
